import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getVehicleListService = (params = {}) => {
  return api.get(url.GET_ALL_VEHICLE, params);
};

export const addVehicleService = (requestParams = {}) => {
  return api.create(url.POST_VEHICLES, requestParams);
};

export const deleteVehicleService = (id) => {
  return api.delete(url.DELETE_VEHICLES(id));
};

export const editVehicleService = (queryParams) => {
  return api.create(url.PUT_VEHICLE, queryParams);
};
